let error = {}

export const validateInput = (name, value, type,emptyValidation,lessThanZeroValidation,lessThanTodayValidation) => {
    switch (type) {
        case 'number':
                if(emptyValidation){
                    (value.length === 0) ? 
                      Object.assign(error, {emptyValidation: "Can not leave quantity empty"})
                    : delete error.emptyValidation
                }
                if(lessThanZeroValidation){
                    (value === "0" || value < 0) ? 
                     Object.assign(error, {lessThanZeroValidation : "Quantity can not set zero or less than zero"})
                    : delete error.lessThanZeroValidation
                }
            break;

            case 'datetime-local':
                if(lessThanTodayValidation){
                    // const selectedDate = new Date(value).toISOString().split(".")[0];
                    // const today = new Date().toISOString().split(".")[0];
                       let selectedDate = new Date(value);
                       let todayDate =  new Date();
                    (selectedDate < todayDate) ? 
                    Object.assign(error, {lessThanTodayValidation : "Date can not be set less than today"})
                    : delete error.lessThanTodayValidation
                }
                
            break;
 };
 return error;
};

// export const justAnAlert = () => {
//    alert('hello');
// };




























